import { ErrorHandler } from '@angular/core';

export class GenericErrorHandler extends ErrorHandler {

  constructor() {
   // The true paramter tells Angular to rethrow exceptions, so operations like 'bootstrap' will result in an error
   // when an error happens. If we do not rethrow, bootstrap will always succeed.
   super();
 }

  handleError(error) {
     // send the error to the server
     super.handleError(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/exception/generic-error-handler.ts